import React from 'react';
import PropTypes from 'prop-types';
import { Draggable } from '@hello-pangea/dnd';
import RenderedListItemUL from './RenderedListItemUL';
import { getItemStyle } from '../../utils/dragDrop';
import tailwindTheme from '../../../../../config/tailwind.config';
import { DndDropIcon } from '../Icons/Icons';

const ListItemUL = ({
  item, children, isDraggable = false, isDragDisabled = false, draggableIndex = 0,
}) => {
  const icon = (
    <div className="flex items-center mt-3 pr-1.5">
      <DndDropIcon
        className="text-inherit"
        color={tailwindTheme.theme.extend.colors['vamos-black']}
        width={24}
        height={24}
      />
    </div>
  );

  if (!isDraggable) {
    return (
      <div className="flex items-center ml-[-30px]">
        {icon}
        <RenderedListItemUL>{children}</RenderedListItemUL>
      </div>
    );
  }

  return (
    <Draggable
      draggableId={String(item.id ? item.id : item.key)}
      isDragDisabled={isDragDisabled}
      index={draggableIndex}
    >
      {(provided, snapshot) => (
        <div
          className="flex items-center ml-[-30px]"
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={getItemStyle(
            snapshot.isDragging,
            provided.draggableProps.style,
          )}
        >
          {icon}
          <RenderedListItemUL isDragging={snapshot.isDragging}>
            {children}
          </RenderedListItemUL>
        </div>
      )}
    </Draggable>
  );
};

ListItemUL.propTypes = {
  item: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  isDraggable: PropTypes.bool,
  isDragDisabled: PropTypes.bool,
  draggableIndex: PropTypes.number,
};

export default ListItemUL;
